import { useState } from 'react';
import { Button } from 'react-bootstrap';

// Components
import EmlToken from 'views/EmlToken/EmlToken';
import TrnsxToken from 'views/TrnsxToken/TrnsxToken';

const TokenFinder = () => {
    const [componentView, setComponentView] = useState(0);
    return (
        <div>
            <div className="d-flex justify-content-center mb-4">
                <Button
                    variant={componentView === 0 ? 'dark' : 'light'}
                    style={{ marginRight: '10px' }}
                >
                    <span onClick={() => setComponentView(0)}>TRNSX E-Code</span>
                </Button>
                <Button variant={componentView === 1 ? 'dark' : 'light'}>
                    <span onClick={() => setComponentView(1)}>EML E-Token</span>
                </Button>
            </div>
            {componentView === 0 && <TrnsxToken />}
            {componentView === 1 && <EmlToken />}
        </div>
    );
};

export default TokenFinder;
